// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3Hpdt","left":"StickyBox_left__1fOj-","right":"StickyBox_right__9q9mV"};